import { useEffect, useState } from 'react';

import { PasswordResetStep } from '@quizzach/interfaces';
import {
	consoleDev,
	ConsoleStatus,
	fetchData,
	validateInput,
} from '@quizzach/utils';

export const useResetPasswordStep1 = () => {
	const [state, setState] = useState({ email: '' });
	const [error, setError] = useState<boolean>(false);
	const [buttonClicked, setButtonClicked] = useState<boolean>(false);
	const [validationErrorState, setValidationErrorStates] = useState<string>('');

	const [resetStep, setResetStep] =
		useState<PasswordResetStep>('reset_requesting');

	const resetPassword = async () => {
		try {
			const response = await fetchData<any>(`/api/user/reset-password`, {
				method: 'POST',
				body: JSON.stringify(state),
			});
			if (response.status >= 300) {
				consoleDev('resetPassword', ConsoleStatus.HTTP, response.status);
				setError(true);
			} else {
				consoleDev('resetPassword', ConsoleStatus.SUCC);
				setResetStep('reset_success');
			}
		} catch (err) {
			consoleDev('resetPassword', ConsoleStatus.NET, err);
			setError(true);
		}
	};

	const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const { name, value } = event.target;
		setState((prevState) => ({
			...prevState,
			[name]: value,
		}));
	};

	const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
		event.preventDefault();
		setButtonClicked(true);

		if (validationErrorState === '') resetPassword();
	};

	useEffect(() => {
		setValidationErrorStates(validateInput('email', state.email));
	}, [state]);

	return {
		state,
		error,
		resetStep,
		buttonClicked,
		validationErrorState,
		handleInputChange,
		onSubmit,
	};
};
